<template>
  <div>
    <ul>
      <li>
        <h5>
          {{ _T('Item Total') }}
          <span>{{ currency }} {{ Num.price(cart_sub_total) }}</span>
        </h5>
      </li>
      <template v-if="order_surcharges && order_surcharges.length">
        <li v-for="(surcharge, key) in order_surcharges" :key="key">
          <h5>
            {{ _T_DB(surcharge.entity, 'name') }}
            <span>
              {{ currency }}
              {{ Num.price(surcharge.surcharge + surcharge.tax) }}
            </span>
          </h5>
        </li>
      </template>
      <li v-if="driver_tip">
        <h5>
          {{ _T('Driver Tip') }}
          <span class="light-font" v-if="driverTip.toString().includes('%')">
            ({{ driverTip }})
          </span>
          <span>{{ currency }} {{ Num.price(driver_tip) }}</span>
        </h5>
      </li>

      <template v-for="(discount, key) in order_discounts">
        <li
          :key="'order_discount_' + key"
          v-if="find_discount_on_order(discount)"
        >
          <h5>
            {{ _T_DB(discount, 'name') }}
            <span class="max-discount" v-if="discount.max_discount_value"
              >({{ _T('max') }}
              {{ Num.price(discount.max_discount_value) }})</span
            >
            <span
              >- {{ currency }}
              {{ Num.price(find_discount_on_order(discount)) }}</span
            >
          </h5>
        </li>
      </template>
      <li v-if="delivery_surcharge">
        <h5>
          {{ _T('Additional Delivery Surcharge') }}
          <span>{{ currency }} {{ Num.price(delivery_surcharge) }}</span>
        </h5>
      </li>
      <li v-if="loyalty_spent">
        <h5>
          {{ _T('Cashback Balance') }}
          <span>- {{ currency }} {{ Num.price(loyalty_spent) }}</span>
        </h5>
      </li>
      <li>
        <div class="cart-checkout p-0">
          <div class="details">
            <h4>{{ _T('Bill Amount') }}</h4>
            <span
              >{{ currency }}
              {{ Num.price(order_total_inc_cashback) }}
            </span>
          </div>
          <div
            class="text-center"
            v-if="
              (web_user || guest_checkout) &&
                windowSize > 767 &&
                !isFloorTableAvailable.table_id
            "
          >
            <p>
              {{ _T('By clicking button “Place Order”,you agree with') }}
              <router-link :to="{ name: 'terms' }">
                {{ _T('Terms') }}{{ _T('&')
                }}{{ _T('Condition and Privacy Policy') }}
              </router-link>
            </p>
            <progress-bar
              v-if="processInProgress(process)"
              :btn-large="true"
            ></progress-bar>
            <template v-if="currentStore">
              <template v-if="!currentStore.website_busy">
                <button
                  v-if="deliveryTimeCalculate"
                  data-toggle="modal"
                  class="btn btn-solid btn-block"
                  @click="$bvModal.show('delivery-time-table')"
                >
                  {{ _T('Checkout') }}
                </button>
                <button
                  v-else
                  @click.stop="checkoutCart()"
                  class="btn btn-solid btn-block"
                  :class="{ disabled: btnDisabled }"
                >
                  {{ _T('Checkout') }}
                </button>
                <router-link
                  :to="{
                    name: brandStoreRoute('store_page'),
                    params: {
                      ...brandStoreParams,
                    },
                  }"
                  class="btn btn-outline btn-block"
                  >{{ _T('Continue shopping') }}</router-link
                >
              </template>
              <template v-else>
                <span class="text-danger">
                  {{
                    _T(
                      '!Sorry we are unable to process your order because of heigh demand, please select another store'
                    )
                  }}.
                </span>
              </template>
            </template>
          </div>
          <div
            v-else-if="isFloorTableAvailable.table_id && windowSize > 767"
            class="text-center"
          >
            <p>
              {{ _T('By clicking button “Place Order”,you agree with') }}
              <router-link :to="{ name: 'terms' }">
                {{ _T('Terms') }}{{ _T('&')
                }}{{ _T('Condition and Privacy Policy') }}
              </router-link>
            </p>
            <progress-bar
              v-if="processInProgress(process)"
              :btn-large="true"
            ></progress-bar>
            <button v-else @click="checkout()" class="btn btn-solid btn-block">
              {{ _T('Place Order') }}
            </button>
            <router-link
              :to="{
                name: brandStoreRoute('store_page'),
                params: {
                  ...brandStoreParams,
                },
              }"
              class="btn btn-outline btn-block"
              >{{ _T('Continue shopping') }}</router-link
            >
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { mapGetters, mapState } from 'vuex'
import simplify from '@/mixins/simplify'
import ProgressBar from '@/components/Elements/ProgressBar'
// import StoreClosedModal from '@/components/Modals/StoreClosedModal.vue'
import WindowSize from '@/mixins/Windowsize.js'
import { isObjectEmpty, objectToString } from '@/utils/main_utils'
import Checkout from '@/mixins/Checkout'
import * as CONST from '@/constants'

export default {
  name: 'Amount',
  mixins: [simplify, WindowSize, Checkout],
  data() {
    return {
      process: 'cart-checkout',
    }
  },
  computed: {
    ...mapState({ driverTip: state => state.cart_store.driverTip }),
    ...mapState({
      futureOrderDateTime: state => state.cart_store.futureOrderDateTime,
    }),
    ...mapGetters([
      'currentDateTime',
      'cart_sub_total',
      'cart_items_count',
      'order_total',
      'order_total_inc_cashback',
      '_T',
      '_T_DB',
      'order_surcharges',
      'driver_tip',
      'cashback',
      'order_discounts',
      'discount_on_order',
      'find_discount_on_order',
      'web_user',
      'processInProgress',
      'brandStoreParams',
      'brandStoreRoute',
      'loyalty_spent',
      'delivery_surcharge',
      'is_customer_logged_in',
      'guest_checkout',
      'customer_address',
      'brandStoreRoute',
      'brandStoreParams',
      'currentStore',
      'deliveryTime',
      'isFloorTableAvailable',
      'order_type',
    ]),
    deliveryTimeCalculate() {
      if (this.futureOrderDateTime) {
        const current_date_store = new Date(this.currentDateTime.current_date)
        const current_date_active = new Date(
          this.futureOrderDateTime.future_date
        )
        if (current_date_active > current_date_store) {
          return false
        }
      }
      if (this.currentDateTime) {
        let time = this.deliveryTime(
          {
            delivery_duration: '0:' + this.currentDateTime.current_time,
          },
          true
        )

        let store_close_time = this.deliveryTime(
          {
            delivery_duration:
              '0:' + this.currentStore.delivery_hours.closes_at,
          },
          true
        )
        let openAt = parseInt(
          this.deliveryTime({
            delivery_duration: '0:' + this.currentStore.delivery_hours.opens_at,
          })
        )
        let closedAt = parseInt(
          this.deliveryTime({
            delivery_duration:
              '0:' + this.currentStore.delivery_hours.closes_at,
          })
        )
        if (openAt >= closedAt) {
          let timeSplit = this.currentStore.delivery_hours.closes_at.split(':')
          let calcTime = openAt + closedAt + 12 + (12 - openAt)
          store_close_time = calcTime * 60 + parseInt(timeSplit[1])
        }
        if (this.currentStore.delivery_hours.all_day_long) {
          store_close_time = 24 * 60
        }
        store_close_time =
          parseInt(store_close_time) -
          parseInt(this.deliveryTime(this.currentStore, true))
        let store_open_time = this.deliveryTime(
          {
            delivery_duration: '0:' + this.currentStore.delivery_hours.opens_at,
          },
          true
        )
        // store_open_time = parseInt(store_open_time) + parseInt(this.deliveryTime(this.currentStore, true))
        if (time > store_open_time && time < store_close_time) {
          // removing or condition from above if (time < closedAt * 60 && time < store_close_time)
          // if open time is 12 and close is 14 or 14 or 18 store not open yet but user can place order by this condition
          return false
        } else if (store_open_time > time) {
          if (this.futureOrderDateTime) {
            return false
          }
          return true
        }
        if (time > store_close_time) {
          return true
        } else return false
      } else return false
    },
    btnDisabled() {
      if (!this.cart_items_count) {
        return true
      }
      if (this.guest_checkout) {
        return this.processInProgress(this.process)
      }
      if (!this.is_customer_logged_in) {
        return true
      }
      return this.processInProgress(this.process)
    },
  },
  methods: {
    checkoutCart() {
      if (this.btnDisabled) {
        return false
      }

      if (this.guest_checkout) {
        let component = undefined
        this.$parent.$parent.$children.forEach($child => {
          if ($child.$refs['guest_checkout_form']) {
            component = $child.$refs['guest_checkout_form']
          }
        })
        // this.$parent.$parent.$children[1].$refs[
        //   'guest_checkout_form'
        // ]
        let guestErrors = component.validateForm()

        if (!isObjectEmpty(guestErrors)) {
          this.$store.dispatch('showNotification', {
            text: objectToString(guestErrors, '</br>'),
            status: 'error',
          })
          this.$store.dispatch('stopProcess', this.process).then(() => {})
          return false
        }
      }
      if (
        !this.customer_address &&
        this.order_type === CONST.ORDER_TYPE_ONLINE
      ) {
        this.$store.dispatch('showNotification', {
          text: this._T('Please provide Delivery Address'),
          status: 'error',
        })
        return Promise.reject(this._T('Please provide Delivery Address'))
      }
      //check if items not available
      if (!this.$store.getters.available_cart_items.length) {
        this.$store.dispatch('showNotification', {
          text: this._T(
            'Sorry item(s) not available in your selected location'
          ),
          status: 'error',
        })
        return Promise.reject(
          this._T('Sorry item(s) not available in your selected location')
        )
      }
      this.$store
        .dispatch('validateCheckout')
        .then(() => {
          this.$router.push({
            name: this.brandStoreRoute('checkout'),
            params: {
              ...this.brandStoreParams,
            },
          })
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log('checkout validation was failed', error)
          this.$store.dispatch('stopProcess', this.process)
        })
    },
  },
  components: {
    ProgressBar,
    // StoreClosedModal,
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  ul {
    @media (max-width: 575px) {
      padding-right: 0;
    }
    li {
      h5 {
        text-align: right;
      }
      span {
        float: left;
      }
      .cart-checkout {
        .details {
          span {
            margin-left: unset;
          }
        }
      }
    }
  }
}
ul {
  padding-top: calc(
    #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
  );
  li {
    display: block;
    h5 {
      margin-bottom: $px16;
    }
    span {
      float: right;
      &.max-discount {
        float: unset;
        font-size: $px11;
      }
    }
    .light-font {
      color: $light-font;
      float: none;
    }
    /*&:nth-child(4) {
      span {
        color: $color-tertiary;
      }
    }*/
    .cart-checkout {
      @media (max-width: 575px) {
        .details {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
        }
      }
    }
  }
}
</style>
